import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { isValidPhoneNumber } from 'libphonenumber-js'
import IMask from 'imask'

const masks = document.querySelectorAll('.vn-phone-mask')
if (masks) {
  ;[...masks].map((mask) => {
    IMask(mask, {
      mask: '+33 \\00 00 00 00 00',
      lazy: false,
      placeholderChar: 'x',
    })
  })
}

window.Parsley.addValidator('frNumber', {
  requirementType: 'string',
  validateString: function (value) {
    return isValidPhoneNumber(value, 'FR')
  },
})

const body = document.body

const setThemeVars = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  const mainContainerWidth = mainContainer.clientWidth

  const col = document.querySelector('.vn-col-sizer')
  const colWidth = col.clientWidth

  const headerContainer = document.querySelector('.site-header')
  const headerContainerHeight = headerContainer.clientHeight

  const vh = window.visualViewport.height

  body.style.setProperty(
    '--space-width',
    `${(documentWidth - mainContainerWidth) / 2 + 20 - 50}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
  body.style.setProperty('--header-height', `${headerContainerHeight}px`)
  body.style.setProperty('--viewport-height', `${vh}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)
window.visualViewport.addEventListener('resize', setThemeVars)

$('.vn-btn-terms button').on('click', function (e) {
  e.preventDefault()
  window.location.href = $(this).attr('data-url')
})

$.ui.autocomplete.prototype._resizeMenu = function () {
  var ul = this.menu.element
  ul.outerWidth(this.element.outerWidth())
}

$('a[href="#cookies"]').on('click', (e) => {
  e.preventDefault()
  window.openAxeptioCookies()
})
